import { MILLISECONDS_IN_A_DAY, TimelineTimeframe } from '@wilson/interfaces';
import { addDays, addMilliseconds } from 'date-fns';

export function getSupposedVisibleInterval({
  scrollLeftOffsetPx,
  pixelPerMs,
  timeframe,
  numberOfDaysInVisibleInterval,
}: {
  scrollLeftOffsetPx: number;
  pixelPerMs: number;
  timeframe: TimelineTimeframe;
  numberOfDaysInVisibleInterval: number;
}): TimelineTimeframe {
  const positiveScrollLeftOffsetPx = Math.max(scrollLeftOffsetPx, 0);
  const amountOfMsScrolled = positiveScrollLeftOffsetPx / pixelPerMs;
  const fullDayScrolled = Math.floor(
    amountOfMsScrolled / MILLISECONDS_IN_A_DAY,
  );
  const remainingMsScrolled = amountOfMsScrolled % MILLISECONDS_IN_A_DAY;
  const newFullStartDate = addDays(timeframe.start, fullDayScrolled);
  const newFullEndDate = addDays(
    newFullStartDate,
    numberOfDaysInVisibleInterval,
  );
  const newStartDate = addMilliseconds(newFullStartDate, remainingMsScrolled);
  const newEndDate = addMilliseconds(
    newFullEndDate,
    remainingMsScrolled - 1000,
  ); // We subtract 1000ms to not overlap to the next day outside of the interval

  return {
    start: newStartDate.getTime(),
    end: newEndDate.getTime(),
  };
}
